module.exports = __webpack_public_path__ + "img/ic_logo.73f05e4b.png";